import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { Auth0Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/auth",
    "logout": "https://hearpeers.medel.com",
    "home": "/dashboard",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "auth0",
  "token": {
    "global": false
  }
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // auth0
  $auth.registerStrategy('auth0', new Auth0Scheme($auth, {
  "domain": "auth.login.medel.com",
  "logoutRedirectUri": "https://hearpeers.medel.com",
  "audience": "https://my.medel.com/api",
  "clientId": "mTNdYNS4YXc2SgP64MyPYxvnFPIUis3x",
  "scope": [
    "openid",
    "profile",
    "email",
    "openid",
    "profile",
    "email",
    "offline_access"
  ],
  "responseType": "code",
  "grantType": "authorization_code",
  "codeChallengeMethod": "S256",
  "name": "auth0",
  "endpoints": {
    "authorization": "https://auth.login.medel.com/authorize",
    "userInfo": "https://auth.login.medel.com/userinfo",
    "token": "https://auth.login.medel.com/oauth/token",
    "logout": "https://auth.login.medel.com/v2/logout"
  }
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
